import { request, buildQuery } from '../../lib/apiClient';
export function listTemplates() {
    return request('/task-templates');
}
export function createTemplate(input) {
    return request('/task-templates', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function deleteTemplate(id) {
    return request(`/task-templates/${id}`, {
        method: 'DELETE',
    });
}
export function listTasks(params) {
    const query = buildQuery({
        status: params?.status,
        assignedInstallerId: params?.assignedInstallerId,
        limit: params?.limit,
        nextToken: params?.nextToken,
    });
    return request(`/internal-tasks${query}`);
}
export function getTask(id) {
    return request(`/internal-tasks/${id}`);
}
export function createTask(input) {
    return request('/internal-tasks', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function updateTask(id, input) {
    return request(`/internal-tasks/${id}`, {
        method: 'PUT',
        body: JSON.stringify(input),
    });
}
export function deleteTask(id) {
    return request(`/internal-tasks/${id}`, {
        method: 'DELETE',
    });
}
export function addNote(id, input) {
    return request(`/internal-tasks/${id}/notes`, {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
//# sourceMappingURL=api.js.map